import { ResettingFileUpload } from '@/components/FileUpload/ResettingFileUpload';
import { Box, Icon, TextareaInput } from '@palmetto/palmetto-components';

import { FlagDocumentTypes } from 'types';

interface ReviewerQCSectionProps {
  newNote: string;
  onNoteChange: (value: string) => void;
  flagFiles: FileList | undefined;
  onFilesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  flagIndexKey: number;
  isPhone: boolean;
  isAccountLoading: boolean;
  isQueueLoading: boolean;
  isUploadingDocument: boolean;
}

export const ReviewerQCSection = ({
  newNote,
  onNoteChange,
  flagFiles,
  onFilesChange,
  flagIndexKey,
  isPhone,
  isAccountLoading,
  isQueueLoading,
  isUploadingDocument,
}: ReviewerQCSectionProps) => {
  return (
    <Box>
      <Box direction="row" gap="xs" padding="sm 0 xs 0" alignItems="center">
        <Icon size="xl" name="reply" />
        <Box>QC response</Box>
      </Box>
      <TextareaInput
        id="new-note"
        name="new-note"
        label=""
        rows={3}
        placeholder="Add an additional note"
        value={newNote}
        onChange={(e) => {
          onNoteChange(e.target.value);
        }}
        isDisabled={isAccountLoading || isQueueLoading}
      />

      <Box padding="xs 0 0 0" alignItems="flex-end" childGap="xs">
        <ResettingFileUpload
          labelText="Upload"
          id={`upload-${FlagDocumentTypes.flag}-files`}
          name={`${FlagDocumentTypes.flag}-files`}
          size="sm"
          multiple
          key={flagIndexKey}
          onChange={onFilesChange}
          buttonText={!isPhone ? 'Upload flag file(s)' : null}
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => event.stopPropagation()}
          isDisabled={isUploadingDocument}
          files={flagFiles}
          display="flex"
          alignItems="flex-end"
        />
        <Box fontSize="sm" color="placeholder">
          {'image files only (jpg, png, gif)'}
        </Box>
      </Box>
    </Box>
  );
};
